jQuery(document).on('submit', 'form.api-form', function (e) {
    e.preventDefault();

    submitData($(this));

});

function submitData(form) {
    var api_route = form.data('api-route');
    var submitdata = form.serializeArray();
    var refresh_after_submit = form.data('refresh-after-submit')

    if (!api_route) {
        return;
    }

    form.addClass('form--loading');
    form.find(':submit').prop('disabled', true);
    submitdata.push({'name': 'blog_id', 'value': cfpluginvars.blog_id})

    $.ajax({
        type: 'POST',
        dataType: 'json',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + cfpluginvars.bearer_token);
        },
        url: cfpluginvars.api_uri + api_route,
        data: submitdata,
    }).done(function (data, textStatus, jqXHR) {
        if (data.pdf && data.filename) {
            var a = document.createElement('a');
            var blob = base64ToBlob(data.pdf, 'application/pdf');
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = data.filename;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }).success(function (data) {
        if (data.redirect) {
            window.location.href = data.redirect;
        } else if (refresh_after_submit) {
            window.location.reload();
        } else {
            removeInvalids(form);
        }
    }).fail(function (data) {
        if (typeof data.responseJSON.message != 'undefined') {
            if(data.responseJSON.message === "[Rmg Guard] Expired token") {
                resetToken(true);
                submitData(form);
            }
        }
        removeInvalids(form);

        if (typeof data.responseJSON.errors != 'undefined') {

            $.each(data.responseJSON.errors, function (field_name, error) {
                field_name = dotToArray(field_name);
                form.find('[name="' + field_name + '"], label[for="' + field_name + '"]').first().parent().addClass('is-invalid').append(
                    "<div class='invalid-feedback d-block'>" + error + "</div>"
                );
            });
        }
    }).always(function () {

    });

    function dotToArray(str) {
        var output = '';
        var chucks = str.split('.');
        if(chucks.length > 1){
            for(i = 0; i < chucks.length; i++){
                if(i == 0){
                    output = chucks[i];
                }else{
                    output += '['+chucks[i]+']';
                }
            }
        }else{
            output = chucks[0];
        }

        return output
    }

    function removeInvalids(form) {
        form.find('.is-invalid').removeClass('is-invalid');
        form.find('.invalid-feedback').remove();

        form.find(':submit').prop('disabled', false);
        form.removeClass('form--loading');
    }

    function base64ToBlob(base64, mimetype, slicesize) {
        if (!window.atob || !window.Uint8Array) {
            // The current browser doesn't have the atob function. Cannot continue
            return null;
        }
        mimetype = mimetype || '';
        slicesize = slicesize || 512;
        var bytechars = atob(base64);
        var bytearrays = [];
        for (var offset = 0; offset < bytechars.length; offset += slicesize) {
            var slice = bytechars.slice(offset, offset + slicesize);
            var bytenums = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                bytenums[i] = slice.charCodeAt(i);
            }
            var bytearray = new Uint8Array(bytenums);
            bytearrays[bytearrays.length] = bytearray;
        }
        return new Blob(bytearrays, {type: mimetype});
    };
}

function resetToken(once = false)
{
    $.ajax({
        type: 'get',
        url: cfpluginvars.ajax_url,
        data: {
            action: 'cf_fresh_token'
        },
        success:function(data)
        {
            if (typeof data.data != 'undefined') {
                cfpluginvars.bearer_token = data.data;
            } else {
                once = true;
            }

            if (!once) {
                setTimeout(function () {
                    resetToken();
                }, 60 * 1000); // every minute
            }
        }
    });
};

resetToken();